export const exposureLimit = 50000;
